module.exports = __webpack_public_path__ + "build_instructions_collaped_1.png?2dfd6bb452b6b032cc704c95e759021f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/build_instructions_collaped_1.png
// module id = 86
// module chunks = 0